import HtmlSVG from "Images/icons/html5.svg";
import CssSVG from "Images/icons/css3.svg";
import JavascriptSVG from "Images/icons/js.svg";
import ReactSVG from "Images/icons/react.svg";
import NodeSVG from "Images/icons/nodejs.svg";
import MongoSVG from "Images/icons/mongodb.svg";
import ExpressSVG from "Images/icons/express.svg";
import GitSVG from "Images/icons/git.svg";
import VScodeSVG from "Images/icons/vscode.svg";
import GatsbySVG from "Images/icons/gatsby.svg";
import DigitalOceanSVG from "Images/icons/digital-ocean.svg";
import StoryblokSVG from "Images/icons/storyblok.svg";
import HerokuSVG from "Images/icons/heroku.svg";
import GraphQlSVG from "Images/icons/graphql.svg";
import SketchSVG from "Images/icons/sketch.svg";
import JestSVG from "Images/icons/jest.svg";
import BuildKiteSVG from "Images/icons/buildkite.svg";
import ContentfulSVG from "Images/icons/contentful.svg";
import prettierSVG from "Images/icons/prettier.svg";
import awsSVG from "Images/icons/aws.svg";
import lambdaSVG from "Images/icons/lambda.svg";
import dynamodbSVG from "Images/icons/dynamodb.svg";
import StyledComponentsSVG from "Images/icons/styled-components.svg";
import nextJsSVG from "Images/icons/nextjs.svg";
import figmaSVG from "Images/icons/figma.svg";

const skillsIcons = [
  {
    label: "HTML5",
    image: HtmlSVG,
    category: "Frontend"
  },
  {
    label: "CSS3",
    image: CssSVG,
    category: "Frontend"
  },
  {
    label: "Javascript",
    image: JavascriptSVG,
    category: "Frontend"
  },
  {
    label: "ReactJS",
    image: ReactSVG,
    category: "Frontend"
  },
  {
    label: "NodeJS",
    image: NodeSVG,
    category: "Backend"
  },
  {
    label: "MongoDB",
    image: MongoSVG,
    category: "Backend"
  },
  {
    label: "Express",
    image: ExpressSVG,
    category: "Backend"
  },
  {
    label: "git",
    image: GitSVG,
    category: "Tools"
  },
  {
    label: "VScode",
    image: VScodeSVG,
    category: "Tools"
  },
  {
    label: "Gatsby",
    image: GatsbySVG,
    category: "Frontend"
  },
  {
    label: "NextJs",
    image: nextJsSVG,
    category: "Frontend"
  },
  {
    label: "Digital Ocean",
    image: DigitalOceanSVG,
    category: "Backend"
  },
  {
    label: "StoryBlok",
    image: StoryblokSVG,
    category: "Frontend"
  },
  {
    label: "Heroku",
    image: HerokuSVG,
    category: "Backend"
  },
  {
    label: "GraphQl",
    image: GraphQlSVG,
    category: "Backend"
  },
  {
    label: "Sketch",
    image: SketchSVG,
    category: "Tools"
  },
  {
    label: "Figma",
    image: figmaSVG,
    category: "Tools"
  },
  {
    label: "BuildKite",
    image: BuildKiteSVG,
    category: "Backend"
  },
  {
    label: "Jest",
    image: JestSVG,
    category: "Tools"
  },
  {
    label: "Styled Components",
    image: StyledComponentsSVG,
    category: "Frontend"
  },
  {
    label: "Contentful",
    image: ContentfulSVG,
    category: "Frontend"
  },
  {
    label: "Prettier",
    image: prettierSVG,
    category: "Tools"
  },
  {
    label: "AWS",
    image: awsSVG,
    category: "Backend"
  },
  {
    label: "Lambda",
    image: lambdaSVG,
    category: "Backend"
  },
  {
    label: "Dynamodb",
    image: dynamodbSVG,
    category: "Backend"
  }
];

export default skillsIcons;
